import type { PropsWithChildren } from 'react';

import { SingleColumnLayout } from '../SingleColumnLayout/SingleColumnLayout';

import styles from './Traffic.module.scss';

type Props = {
	hasNoContent?: boolean;
	formattedTimestamp?: string | null;
	formattedTimestampDateTime?: string | null;
};

export function Traffic({ children, formattedTimestamp, formattedTimestampDateTime }: PropsWithChildren<Props>) {
	return (
		<SingleColumnLayout contentClassName={styles.content}>
			{!!formattedTimestampDateTime && (
				<p className={`body6 ${styles.timestamp}`}>
					Zuletzt aktualisiert: <time dateTime={formattedTimestampDateTime}>{formattedTimestamp}</time>
				</p>
			)}

			<h1 className={styles.title}>Verkehr, Gefahrenmeldungen und Unterrichtsausfälle</h1>

			{children}
		</SingleColumnLayout>
	);
}
